export const TEMPLATES_LIST = "TEMPLATES_LIST";
export const TEMPLATES_LIST_SUCCESS = "TEMPLATES_LIST_SUCCESS";
export const TEMPLATES_LIST_FAIL = "TEMPLATES_LIST_FAIL";

export const EDIT_TEMPLATES = "EDIT_TEMPLATES";
export const EDIT_TEMPLATES_SUCCESS = "EDIT_TEMPLATES_SUCCESS";
export const EDIT_TEMPLATES_FAIL = "EDIT_TEMPLATES_FAIL";

export const UPDATE_TEMPLATES = "UPDATE_TEMPLATES";
export const UPDATE_TEMPLATES_SUCCESS = "UPDATE_TEMPLATES_SUCCESS";
export const UPDATE_TEMPLATES_FAIL = "UPDATE_TEMPLATES_FAIL";

export const ADD_TEMPLATES = "ADD_TEMPLATES";
export const ADD_TEMPLATES_SUCCESS = "ADD_TEMPLATES_SUCCESS";
export const ADD_TEMPLATES_FAIL = "ADD_TEMPLATES_FAIL";

export const DELETE_TEMPLATES = "DELETE_TEMPLATES";
export const DELETE_TEMPLATES_SUCCESS = "DELETE_TEMPLATES_SUCCESS";
export const DELETE_TEMPLATES_FAIL = "DELETE_TEMPLATES_FAIL";
